import { IDefinitionParameter } from "@/types/map";
import Axios from "axios";
import { loadModules } from "esri-loader";
import ToolTip from "../../Overlays/arcgis/ToolTip";
export class LayerDefinition {
  private static intances: Map<string, any>;
  private view!: any;
  private className: string = "layerdefinition";
  private queryUrl: string =
    "http://139.224.210.229:9097/yangpu-api/traffic/getList";
  private labels: Array<any> = new Array<any>();
  private aroundLabels: Array<any> = new Array<any>();
  private aroundlayLayer!: __esri.GraphicsLayer;
  private tips: Array<any> = Array<any>();

  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView | __esri.SceneView) {
    let id = view.container.id;
    if (!LayerDefinition.intances) {
      LayerDefinition.intances = new Map();
    }
    let intance = LayerDefinition.intances.get(id);
    if (!intance) {
      intance = new LayerDefinition(view);
      LayerDefinition.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (LayerDefinition.intances as any) = null;
  }
  private async createOverlayLayer(): Promise<__esri.GraphicsLayer> {
    type MapModules = [typeof import("esri/layers/GraphicsLayer")];
    const [GraphicsLayer] = await (loadModules([
      "esri/layers/GraphicsLayer",
    ]) as Promise<MapModules>);
    let overlayLayer: __esri.GraphicsLayer = new GraphicsLayer();
    (overlayLayer as any).label = "layerDefinition";
    this.view.map.add(overlayLayer);
    this.aroundlayLayer = overlayLayer;
    return overlayLayer;
  }
  public async startLayerDefinition(
    params: IDefinitionParameter
  ): Promise<void> {
    if (!this.aroundlayLayer) {
      await this.createOverlayLayer();
    } else {
      this.aroundlayLayer.removeAll();
    }
    let layerName = params.layerName || "";

    let searchNames = params.searchNames || [];
    let dataSource = params.dataSource || { url: "" };

    let displayField = params.displayField || "Name"; //默认显示图层文字字段
    let searchField = params.searchField || displayField;
    let joinField = dataSource.joinField || "deptName"; //数据关联图层的字段
    let dataField = dataSource.dataField || "totalScore"; //显示数据的字段
    let url = dataSource.url;
    let layerData = dataSource.data;
    let visible = params.visible !== false;
    let showLabel = params.showLabel !== false;
    let expand = params.expand === true;
    let factor = params.factor;
    let xoffset = params.xoffset === undefined ? 0 : params.xoffset;
    let yoffset = params.yoffset === undefined ? 0 : params.yoffset;

    this.tips = params.tips || [];

    let layer = this.getLayer(layerName);
    if (layer === undefined) {
      return;
    }
    let _this = this;
    if (layerData) {
      //如果有数据
      _this.doLayerDefinition({
        layer: layer,
        searchNames: searchNames,
        datas: layerData,
        layerName,
        visible,
        displayField,
        searchField,
        joinField,
        dataField,
        expand,
        xoffset,
        yoffset,
        factor,
        showLabel,
      });
    } else {
      //如果没有数据查询
      this.queryLayerData(url).then((data: any) => {
        _this.doLayerDefinition({
          layer: layer,
          searchNames: searchNames,
          datas: data,
          layerName,
          visible,
          displayField,
          searchField,
          joinField,
          dataField,
          expand,
          factor,
          xoffset,
          yoffset,
          showLabel,
        });
      });
    }
  }
  public queryLayerData(url: string | undefined): Promise<any> {
    let data = [];
    return new Promise((resolve, reject) => {
      if (url !== undefined && url !== "") {
        Axios.post(url, {}).then((res: any) => {
          //todo
          resolve(res.data.data);
        });
      } else {
        resolve([]);
      }
    });
  }
  private getLayer(layerName: string): any {
    if (layerName == "" || layerName == undefined) {
      return undefined;
    }
    let selLayer;
    this.view.map.allLayers.toArray().forEach((layer: any) => {
      if (
        layer.type == "imagery" ||
        layer.type == "map-image" ||
        layer.type == "feature"
      ) {
        if (layer.label == layerName) {
          selLayer = layer;
        }
      }
    });
    return selLayer;
  }
  private async doLayerDefinition(option: any): Promise<any> {
    let layer = option.layer;
    let queryLayer;
    let searchNames = option.searchNames;
    let displayField = option.displayField;
    let searchField = option.searchField;
    let express = "1=1";
    let searchStr = "";
    let xoffset = option.xoffset === undefined ? 0 : option.xoffset;
    let yoffset = option.yoffset === undefined ? 0 : option.yoffset;
    if (searchNames && searchNames.length > 0) {
      searchNames.forEach((name: string, index: number) => {
        if (index === 0) {
          searchStr = searchStr + "(" + searchField + "='" + name + "' ";
        } else {
          searchStr = searchStr + " or " + searchField + "='" + name + "' ";
        }
      });
      searchStr += ")";
      express = searchStr;
    }

    if (layer.type == "feature") {
      layer.definitionExpression = express;
      queryLayer = layer;
    } else if (layer.type == "map-image") {
      var sublayer = layer.findSublayerById(0);
      queryLayer = sublayer;
      if (sublayer) {
        sublayer.definitionExpression = express;
      }
    }
    const query = queryLayer.createQuery();
    query.where = express;
    const results = await queryLayer.queryFeatures(query);
    if (results.features && results.features.length > 0) {
      layer.visible = option.visible !== false;
    } else {
      layer.visible = false;
    }
    let symbol = {};

    if (option.showLabel) {
      if (layer.labelingInfo && layer.labelingInfo.length > 0) {
        layer.labelsVisible = false;
        symbol = layer.labelingInfo[0].symbol;
      }
      this.showLabel(results.features, option, symbol);
    }

    let _this = this;

    let target =
      option.expand || option.factor
        ? results.features[0].geometry.extent
            .clone()
            .expand(option.factor || 0.5)
        : results.features;
    if (xoffset != 0 || yoffset != 0) {
      let ext = option.factor
        ? results.features[0].geometry.extent.clone().expand(option.factor)
        : results.features[0].geometry.extent.clone();
      ext.xmax = ext.xmax + xoffset;
      ext.ymax = ext.ymax + yoffset;
      target = ext;
    }
    if (option.factor === undefined || option.factor > 0) {
      this.view.goTo({ target: target }).then(() => {
        if (_this.tips.length > 0 && results.features.length == 1) {
          _this.createAround(results.features[0]);
        }
      });
    }
  }
  private async clearLabel(layerName: string) {
    this.labels.forEach((obj: any) => {
      if (obj.layerName === layerName) {
        obj.tooltip.remove();
      }
    }, this);
    this.labels = [];
    this.aroundLabels.forEach((obj: any) => {
      obj.remove();
    }, this);
    this.aroundLabels = [];
  }
  private async showLabel(featues: any[], option: any, symbol: any) {
    let layerName = option.layerName;
    this.clearLabel(layerName);
    let data: any = {};
    let datas = option.datas;
    let displayField = option.displayField;
    let joinField = option.joinField;
    let dataField = option.dataField;

    //label 样式
    let color = symbol.color
      ? "rgb(" +
        symbol.color.r +
        "," +
        symbol.color.g +
        "," +
        symbol.color.b +
        ")"
      : "white";
    let fontSize = symbol.font
      ? (symbol.font.size * 0.75).toFixed(0) + "px"
      : "14px";
    let weight = symbol.font ? symbol.font.weight : "nomal";

    datas.forEach((item: any) => {
      data[item[joinField]] = item[dataField];
    });
    featues.forEach((graphic: any, index: number) => {
      let name = graphic.attributes[displayField];
      let valueStr = data[name]
        ? "</span><br/>" +
          "<span style='color:" +
          color +
          ";font-size:" +
          fontSize +
          ";font-weight:" +
          weight +
          ';font-family:"Microsoft YaHei"\' >' +
          data[name] +
          "</span>"
        : "";
      let customtool = new ToolTip(
        this.view,
        {
          id: this.className + index.toString(),
          className: this.className,
          content:
            "<span style='color:" +
            color +
            ";font-size:" +
            fontSize +
            ";font-weight:" +
            weight +
            ';font-family:"Microsoft YaHei"\' >' +
            name +
            valueStr,
        },
        graphic
      );
      this.labels.push({
        tooltip: customtool,
        layerName,
      });
    }, this);
  }
  private createAround(graphic: any) {
    let geometry = graphic.geometry;
    // let tootips = tips.map((item: any) => {
    //   return new ToolTip(this.view, item.tooltip, item.geometry);
    // });
    this.getAroundPoint(geometry);
  }
  private async getAroundPoint(geometry: any) {
    const [Graphic, geometryEngine] = await loadModules([
      "esri/Graphic",
      "esri/geometry/geometryEngine",
    ]);
    let extent1 = geometry.extent;
    //let extent2 = geometry.extent.expand(1.5);
    let ySum = extent1.ymax - extent1.ymin;
    let yStep = ySum / 4;
    let lines = [];
    for (let i = 1; i < 4; i++) {
      let path = [
        [extent1.xmin, extent1.ymin + yStep * i],
        [extent1.xmax, extent1.ymin + yStep * i],
      ];
      lines.push({ type: "polyline", paths: [path] });
    }
    let arounds: any[] = [];
    lines.forEach((line: any, index: number) => {
      let geo = geometryEngine.intersect(geometry, line);
      //console.log(geo);
      // this.view.graphics.add(
      //   new Graphic({
      //     geometry: geo,
      //     symbol: {type: "simple-line", color: "white", width: 4}
      //   })
      // );
      let p0 = geo.getPoint(0, 0);
      let p1 = geo.getPoint(geo.paths.length - 1, 1);
      let linePoint: any = {};
      if (p0.x < p1.x) {
        linePoint = { start: p0, end: p1 };
      } else {
        linePoint = { start: p1, end: p0 };
      }
      let xoffset = 0;
      let yoffset = 0;
      let pos = "-bottom";
      let index1 = 1;
      let index2 = 2;
      if (index === 0) {
        //最底下的横线
        index1 = 1;
        index = 2;
        xoffset = 10;
        yoffset = 10;
      } else if (index === 1) {
        index1 = 5;
        index2 = 6;
        xoffset = 10;
        yoffset = 10;
        //中间横线
      } else if (index === 2) {
        //最上面横线
        index1 = 3;
        index2 = 4;
        xoffset = 10;
        yoffset = 10;
        pos = "-top";
      }
      arounds.push(
        {
          point: [linePoint.start.x, linePoint.start.y],
          pos: "left" + pos,
          index: index1,
        },
        {
          point: [linePoint.end.x, linePoint.end.y],
          pos: "right" + pos,
          index: index2,
        }
      );
      arounds.sort((el1: any, el2: any) => {
        return el1.index - el2.index;
      });
    });
    //画线,添加弹窗
    this.tips.forEach((tip: any, index: number) => {
      let around = arounds[index];
      let pos = tip.pos || around.point;
      this.addToolTip({ x: pos[0], y: pos[1] }, tip, around.pos);
    }, this);
  }
  private addToolTip(geometry: any, tip: any, pos: string) {
    if (!tip.anchor) {
      tip.anchor = pos;
    }
    let ctip = new ToolTip(this.view, tip, geometry);
    this.aroundLabels.push(ctip);
  }
}
